import { render } from "./SkipLogin.vue?vue&type=template&id=15f37812"
import script from "./SkipLogin.vue?vue&type=script&lang=js"
export * from "./SkipLogin.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__